var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.872,
    height: 13.915,
    viewBox: "0 0 15.872 13.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle",
    transform: "translate(0.77 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M7.544,3.557l-5.809,9.7a1.372,1.372,0,0,0,1.173,2.057H14.526A1.372,1.372,0,0,0,15.7,13.254L9.89,3.557a1.372,1.372,0,0,0-2.345,0Z",
    transform: "translate(-1.552 -2.897)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 2.743,
    transform: "translate(7.165 4.185)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 0.007,
    transform: "translate(7.165 9.671)",
    fill: "none",
    stroke: "#f09d18",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribeIcon);
export default __webpack_public_path__ + "static/media/unsubscribe-icon.e51d4f4af54c514684cdfee24aebe7b0.svg";
export { ForwardRef as ReactComponent };